import React from "react";
import { FaSearch, FaTimes } from "react-icons/fa";
import clsx from "clsx";

interface SearchBarProps {
  searchQuery: string;
  setSearchQuery: (q: string) => void;
  disabled?: boolean;
  searchInputClassName?: string;
  searchInputRef?: React.RefObject<HTMLInputElement | null>;
}

const SearchBar: React.FC<SearchBarProps> = ({
  searchQuery,
  setSearchQuery,
  disabled,
  searchInputClassName,
  searchInputRef,
}) => (
  <div className="flex items-center px-4 py-2 border-b border-gray-200 bg-transparent">
    <FaSearch className="mr-2 text-gray-400" />
    <input
      type="text"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      placeholder="Buscar..."
      className={clsx(
        "flex-1 border-none outline-none bg-transparent text-base text-[#201f1e]",
        searchInputClassName
      )}
      autoFocus
      disabled={disabled}
      aria-label="Buscar opções"
      tabIndex={0}
      onKeyDown={e => e.stopPropagation()}
      ref={searchInputRef}
    />
    {searchQuery && (
      <FaTimes
        className="ml-2 text-gray-400 cursor-pointer"
        onClick={() => setSearchQuery("")}
        role="button"
        aria-label="Limpar busca"
        tabIndex={0}
      />
    )}
  </div>
);

export default SearchBar;